import { type ProcessedOption } from "@/components/site-builder/modules/CustomFormModule/types";
import { flattenOptions } from "@/components/site-builder/modules/CustomFormModule/utils/options/flattenOptions";
import { processTreeOptions } from "@/components/site-builder/modules/CustomFormModule/utils/options/processTreeOptions";
import { type FormBuilderFieldOption } from "@/types/form-builder";

export interface ProcessOptionsProps {
  options: FormBuilderFieldOption[];
  showAsTree?: boolean;
  hideParentCheckBoxes?: boolean;
  alwaysShowHeading?: boolean;
}

export function processOptions(props: ProcessOptionsProps): ProcessedOption[] {
  const {
    options = [],
    showAsTree = false,
    alwaysShowHeading = false,
    hideParentCheckBoxes = false,
  } = props;

  if (!options || options.length === 0) {
    return [];
  }

  if (!showAsTree) {
    return flattenOptions(options);
  }

  return processTreeOptions({
    options,
    hideParentCheckBoxes,
    alwaysShowHeading,
  });
}
